module.exports = __webpack_public_path__ + "media/images/area/accommodation-e4f4e7be91c81df127e5dd46c54e3f79.jpg";